function touchCoords(event) {
  const touches = event.touches,
        changedTouches = event.changedTouches;
  return touches && touches[0] || changedTouches && changedTouches[0];
}

export { touchCoords as default };